const defaultHeaders = {
  "Content-Type": "application/json",
};

export let bookingBaseUrl = '';
export let mntBaseUrl = '';
export let subBaseUrl = '';

export function updateBaseUrls(config: { 
  mntBaseUrl: string; 
  bookingBaseUrl: string; 
  subBaseUrl: string 
}) {
  mntBaseUrl = config.mntBaseUrl;
  bookingBaseUrl = config.bookingBaseUrl;
  subBaseUrl = config.subBaseUrl;
}

async function sendData(
  url = "",
  method: "put" | "post",
  data = {},
  type: string,
  token: string
) : Promise<{ response: any; error: unknown; } | undefined> {
  if (token) {
    let response: any, error;
    const tokenHeader = { Authorization: `Bearer ${token}` };
    try {
      switch (type) {
        case "mnt":
          response = await fetch(
            buildUrl(mntBaseUrl, url),
            {
              method: method,
              headers: { ...defaultHeaders, ...tokenHeader },
              body: JSON.stringify(data),
            }
          );
          break;
        case "booking":
          response = await fetch(
            buildUrl(bookingBaseUrl, url),
            {
              method: method,
              headers: { ...defaultHeaders },
              body: JSON.stringify(data),
            }
          );
          break;
        case "sub":
          response = await fetch(
            buildUrl(subBaseUrl, url),
            {
              method: method,
              headers: { ...defaultHeaders },
              body: JSON.stringify(data),
            }
          );
          break;
      }
      const contentType = response.headers.get("content-type");
      if (response.ok) {
        if (contentType && contentType.indexOf("application/json") !== -1) {
          response = await response.json();
        } else {
          response = await response.text();
        }
      } else {
        throw new Error(response.statusText);
      }
    } catch (err) {
      error = err;
      console.error(error);
    }
    return { response, error };
  }
}

async function deleteData(url = "", token: string) {
  if (token) {
    let response: any, error;
    const tokenHeader = { Authorization: `Bearer ${token}` };
    try {
      response = await fetch(buildUrl(mntBaseUrl, url), {
        method: "DELETE",
        headers: { ...tokenHeader },
      });
      const contentType = response.headers.get("content-type");
      if (response.ok) {
        if (contentType && contentType.indexOf("application/json") !== -1) {
          response = await response.json();
        } else {
          response = await response.text();
        }
      } else {
        throw new Error(response.status);
      }
    } catch (err) {
      error = { message: err, status: response.status };
      console.error(error);
    }
    return { response, error };
  }
}

async function getData(url = "", type: string, token: string) {
  if (token) {
    let response: any;
    let error: any;
    const tokenHeader = { Authorization: `Bearer ${token}` };
    try {
      switch (type) {
        case "mnt":
          response = await fetch(
            buildUrl(mntBaseUrl, url),
            {
              method: "GET",
              headers: { ...tokenHeader },
            }
          );
          break;
        case "booking":
          response = await fetch(
            buildUrl(bookingBaseUrl, url),
            {
              method: "GET",
            }
          );
          break;
        case "sub":
          response = await fetch(
            buildUrl(subBaseUrl, url),
            {
              method: "GET",
            }
          );
          break;
      }
      const contentType = response.headers.get("content-type");
      if (response.ok) {
        if (contentType && contentType.indexOf("application/json") !== -1) {
          response = await response.json();
        } else {
          response = await response.text();
        }
      } else {
        throw new Error(response.status);
      }
    } catch (err) {
      error = { message: err, status: response.status };
      console.error(error);
    }
    return { response, error };
  }
}

async function downloadData(
  url = "",
  type: string,
  token: string,
  name: string
) {
  if (token) {
    let data: any, response: any, error;
    const tokenHeader = { Authorization: `Bearer ${token}` };
    try {
      switch (type) {
        case "mnt":
          response = await fetch(
            buildUrl(mntBaseUrl, url),
            {
              method: "GET",
              headers: tokenHeader,
            }
          );
          break;
        case "booking":
          response = await fetch(
            buildUrl(bookingBaseUrl, url),
            {
              method: "GET",
              headers: tokenHeader,
            }
          );
          break;
        case "sub":
          response = await fetch(
            buildUrl(subBaseUrl, url),
            {
              method: "GET",
              headers: tokenHeader,
            }
          );
          break;
      }

      if (response.ok) {
        const blob = await response.blob();
        const fileURL = URL.createObjectURL(blob);
        // create <a> tag dinamically
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;

        // it forces the name of the downloaded file
        fileLink.download = name;

        // triggers the click event
        fileLink.click();
      } else {
        throw new Error("Something went wrong.");
      }
    } catch (err) {
      error = err;
      console.error(error);
    }
    return { response: data, error };
  }
}

function buildUrl(baseUrl:string, path:string) {
  // Remove trailing slash from baseUrl if it exists
  const cleanBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  // Remove leading slash from path if it exists
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${cleanBase}/${cleanPath}`;
}

export { deleteData, downloadData, getData, sendData, buildUrl};
